// Retry pacing for a failed read: each kind of request keeps its own count of consecutive failures
// and waits this long before asking again. Any success resets the count (the caller's). Data that is
// genuinely absent is never a failure (a tile the index does not list, a probed 404), so nothing
// retries it.

/** The pause after `fails` consecutive failures: `firstMs`, doubling, capped at `capMs`. */
export const backoffMs = (fails: number, firstMs: number, capMs: number): number =>
  Math.min(capMs, firstMs * 2 ** Math.max(0, fails - 1));

/** The view's data — the chart frame, the compute's depth/σ tiles, the charted hazards, the chart
 *  markings — is asked again this long after a failure (the first pause of its backoff). The app and
 *  the worker read this one constant. */
export const DATA_RETRY_MS = 10_000;
/** The longest pause of a view-data backoff: offline for days costs one read every few minutes. */
export const DATA_RETRY_CAP_MS = 5 * 60_000;
